import React, { useState } from "react";
import "../styles/LiveSessionCard.css";
import LiveThumbnail from "../../../assets/images/LiveSession/live_thumbnail.png";
import StartAt from "../../../assets/images/calender/sand-clock-starts.png";
import EndsBy from "../../../assets/images/calender/sand-clock-ends.png";
import Link from "../../../assets/images/LiveSession/link.png";
import Lock from "../../../assets/images/LiveSession/lock.png";
import QuestionTooltip from "../../../components/TooltipComponent";
interface LiveSession {
  session_url: string | null;
  session_password: string | null;
  registered: boolean;
}
interface LiveSessionCardProps {
  card: {
    event_id: string;
    program_id: string;
    program_title: string;
    event_type: string;
    event_title: string;
    event_description: string | null;
    event_duration: string;
    start_date: string;
    end_date: string;
    start_time: string;
    end_time: string;
    live_session: LiveSession;
    registration_deadline?: string | null;
    prerequisites?: string | null;
    learning_outcomes?: string | null;
  };
  handleonclick?: () => void;
  tabstatus?: string;
  liveActiveTab?: number;
}

const LiveSessionCard: React.FC<LiveSessionCardProps> = ({
  card,
  handleonclick,
  tabstatus,
  liveActiveTab,
}) => {
  const [showFullDesc, setShowFullDesc] = useState(false);

  const toggleDescription = () => setShowFullDesc(!showFullDesc);

  const truncateText = (text: string, maxLength: number) => {
    return text.length > maxLength
      ? text.substring(0, maxLength) + "..."
      : text;
  };
  return (
    <div className="live-session-card-container">
      <div
        className={`live-session-card ${
          liveActiveTab === 2 ? "live-session-card-completed" : ""
        }`}
        style={{
          opacity: liveActiveTab === 2 ? "80%" : "",
          height: liveActiveTab === 2 ? "210px" : "240px",
        }}
      >
        {/* <div className="live-session-card-image-container">
          <img
            alt="Live Session Thumbnail"
            src={LiveThumbnail}
            className="live-session-card-img"
          />
        </div> */}
        <div className="live-session-card-body">
          <div className="live-session-card-title">
            {card.program_title || ""}
          </div>
          <div
            className="live-session-card-event-title"
            title={card.event_title}
          >
            {truncateText(card.event_title, 22)}
          </div>
          <div className="live-session-card-event-desc">
            <QuestionTooltip text={card.event_description!} />
          </div>
          {/* Start Time */}
          <div className="live-session-card-duration">
            <img
              alt="Clock Icon"
              src={StartAt}
              className="live-session-card-clock-image"
            />
            <div className="live-session-card-text-start-label">Starts at:</div>

            <div className="live-session-card-text-startend-value">
              {card.start_date
                ? new Date(card.start_date)
                    .toLocaleDateString("en-GB")
                    .replace(/\//g, ".")
                : ""}
              {card.start_time ? ` | ${card.start_time}` : ""}
            </div>
          </div>

          {/* End Time */}
          <div className="live-session-card-duration">
            <img
              alt="Clock Icon"
              src={EndsBy}
              className="live-session-card-clock-image"
            />
            <div className="live-session-card-text-ends-label">Ends by:</div>

            <div className="live-session-card-text-startend-value">
              {card.end_date
                ? new Date(card.end_date)
                    .toLocaleDateString("en-GB")
                    .replace(/\//g, ".")
                : ""}
              {card.end_time ? ` | ${card.end_time}` : ""}
            </div>
          </div>

          {/* Session URL */}
          {card.live_session.session_url && liveActiveTab !== 2 && (
            <div className="live-session-card-duration">
              <img
                alt="Link Icon"
                src={Link}
                className="live-session-card-clock-image"
              />
              <div className="live-session-url-container">
                <div className="live-session-card-text-ends-label">
                  Session URL:
                </div>
                <a
                  href={card.live_session.session_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="live-session-card-text-sessionurl-value"
                  title={card.live_session.session_url}
                >
                  {truncateText(card.live_session.session_url, 20)}
                </a>
              </div>
            </div>
          )}

          {/* Session Pass*/}
          {card.live_session.session_password && liveActiveTab !== 2 && (
            <div className="live-session-card-duration">
              <img
                alt="Lock Icon"
                src={Lock}
                className="live-session-card-clock-image"
              />
              <div className="live-session-card-text-ends-label">
                Session Password:
              </div>
              <div className="live-session-card-text-startend-value">
                {card.live_session.session_password}
              </div>
            </div>
          )}

          {/* Event Registration Notice */}
          {liveActiveTab !== 2 ? (
            card.live_session.registered ? (
              !card.live_session.session_url &&
              !card.live_session.session_password ? (
                <div className="live-session-card-events">
                  <div className="live-session-card-reg-text">
                    *You are successfully registered for the event. Meeting
                    credentials will be displayed here 1 hour before it starts.
                  </div>
                </div>
              ) : (
                <></>
              )
            ) : (
              <button
                className="live-session-reg-button"
                onClick={handleonclick}
              >
                Register
              </button>
            )
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default LiveSessionCard;
